<template>
<div class="wlx-pilot-manager">
    <div class="add-partner-enterprise-head clearfix">
        <div class="top-page-top fl">
            <span class="sp-top-text">委员会会员申请</span>
        </div>
        <div class="fr btn-right">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-select v-model="type" clearable placeholder="请选择申请类型">
                        <el-option label="院校申请" value="0"></el-option>
                        <el-option label="企业申请" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="isPost" clearable placeholder="请选择审核状态">
                        <el-option label="待审核" value="0"></el-option>
                        <el-option label="审核通过" value="1"></el-option>
                        <el-option label="审核未通过" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="unitName" placeholder="单位名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <a class="export-button-a" style="color:#fff" :href="exportExcelStu" v-if="userInfo.isSys">导出</a>
                </el-form-item>
            </el-form>
        </div>
    </div>

    <el-table :data="siteList" @selection-change="handleSelectionChange" style="width: 100%;">
        <!-- <el-table-column prop="Id"  :reserve-selection="true" width="55"></el-table-column> -->
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="unitName" label="单位名称" show-overflow-tooltip width="260"></el-table-column>
        <el-table-column prop="dateCreated" label="创建时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="committeeLead" label="专委会代表人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contact" label="联络人" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="level" label="申请等级" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="邮箱" show-overflow-tooltip v-if="userInfo.isSys"></el-table-column>
        <el-table-column prop="headName" label="负责人签名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" label="申请类型" show-overflow-tooltip>
            <template slot-scope="scope">
                <span v-if="scope.row.type == 0">院校申请</span>
                <span v-if="scope.row.type == 1">企业申请</span>
            </template>
        </el-table-column>
        <el-table-column prop="isPost" label="是否通过" show-overflow-tooltip>
            <template slot-scope="scope">
                <span v-if="scope.row.isPost == 0">未审核</span>
                <span v-if="scope.row.isPost == 1">审核通过</span>
                <span v-if="scope.row.isPost == 2">审核未通过</span>
            </template>
        </el-table-column>
        <el-table-column prop="opinion" label="审核意见" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="150">
            <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="goLook(scope.row.id,scope.row.type)">查看</el-button>
                <el-button type="primary" size="mini" @click="openApply(scope.row)">审核</el-button>
                <!-- <el-button type="danger" size="mini">删除</el-button> -->
            </template>
        </el-table-column>
    </el-table>

    <div class="u-page-con">
        <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" v-show="totalCount > 0" style="text-align: center;"></el-pagination>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" append-to-body width="50%">
        <el-form ref="ruleForm" label-width="160px">
            <el-form-item label="是否通过" prop="title">
                <el-radio-group v-model="ruleForm.isPost">
                    <el-radio :label="1">通过</el-radio>
                    <el-radio :label="2">未通过</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="审核意见" prop="title">
                <el-input type="textarea" :rows="5" v-model="ruleForm.opinion"></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="closeApply()">取 消</el-button>
            <el-button type="primary" @click="auditApply()">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    data() {
        return {
            level: "",
            schoolType: "",
            schoolPrivince: "",
            type: '',
            isPost: '',
            // 省份
            privinceData: "",
            //1、 中职 2、高职 3、本科
            levelList: [{
                    lable: 1,
                    value: "中职",
                },
                {
                    lable: 2,
                    value: "高职",
                },
                {
                    lable: 3,
                    value: "本科",
                },
            ],
            //1、 国示范 2、省示范 3、行业特色校  4、优质校  5 本科
            SchoolTypeList: [{
                    lable: 1,
                    value: "国示范",
                },
                {
                    lable: 2,
                    value: "省示范",
                },
                {
                    lable: 3,
                    value: "行业特色校",
                },
                {
                    lable: 4,
                    value: "优质校",
                },
                {
                    lable: 5,
                    value: "本科",
                },
            ],
            unitName: "",
            siteList: [],
            page: 1,
            pageSize: 10,
            totalCount: 0,
            // 审核
            dialogTitle: "审核",
            dialogVisible: false,
            ruleForm: {
                id: "",
                isPost: 0,
                opinion: ""
            }
        };
    },
    components: {},
    props: {
        certificateId: {
            type: String,
            default: ""
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        exportExcelStu: function () {
            return "/api/XOrg/MemberApplyManager/exportMemberApplyExcel?unitName=" + this.unitName + "&level=" + this.level + "&type=" + this.type + "&isPost=" + this.isPost + "&certificateId=" + this.certificateId;
        },
    },
    created() {
        this.getSessionStorage();
        this.getPilotList();
        this.getProvinceData();
    },
    methods: {
        getProvinceData() {
            this.$http.post("/api/XOrg/Questionnaire/getAllProvinceList").then((res) => {
                if (res.code > 0) {
                    this.privinceData = res.province;
                }
            });
        },
        goLook(id, type) {
            if (type == 1) {
                this.$router.push({
                    name: "qyMemberApplyView",
                    params: {
                        applyId: id,
                    },
                });
            } else {
                this.$router.push({
                    name: "schoolMemberApplyView",
                    params: {
                        applyId: id,
                    },
                });
            }
        },
        // 审核
        openApply(row) {
            this.ruleForm.id = row.id;
            this.ruleForm.isPost = row.isPost;
            this.ruleForm.opinion = row.opinion;
            this.dialogVisible = true;
        },
        auditApply() {
            var that = this;
            this.$http.post("/api/XOrg/MemberApplyManager/auditApply", {
                id: this.ruleForm.id,
                isPost: this.ruleForm.isPost,
                opinion: this.ruleForm.opinion
            }).then((res) => {
                if (res.code > 0) {
                    this.getPilotList();
                    this.closeApply();
                }
            });
        },
        closeApply() {
            this.dialogVisible = false;
            this.ruleForm.id = "";
            this.ruleForm.isPost = 0;
            this.ruleForm.opinion = "";
        },
        handleSelectionChange() {},
        handleSizeChange(val) {
            this.pageSize = val;
            this.getPilotList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getPilotList();
        },
        search() {
            this.page = 1;
            this.getPilotList();
        },
        getPilotList() {
            var that = this;
            this.$http
                .post("/api/XOrg/MemberApplyManager/getMemberApplyList", {
                    unitName: that.unitName,
                    level: that.level,
                    type: this.type,
                    isPost: this.isPost,
                    certificateId: that.certificateId,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then((rst) => {
                    that.siteList = rst.list;
                    that.page = rst.pagination.pageIndex;
                    that.pageSize = rst.pagination.pageSize;
                    that.totalCount = rst.pagination.totalCount;

                    // 参数存储本地缓存
                    sessionStorage.setItem("wlx_committeeApply_unitName", that.unitName);
                    sessionStorage.setItem("wlx_committeeApply_level", that.level);
                    sessionStorage.setItem("wlx_committeeApply_type", that.type);
                    sessionStorage.setItem("wlx_committeeApply_isPost", that.isPost);
                    sessionStorage.setItem("wlx_committeeApply_pageSize", that.pageSize);
                    sessionStorage.setItem("wlx_committeeApply_page", that.page);
                });
        },
        // 获取网页缓存信息
        getSessionStorage() {
            // 获取网页缓存信息
            var unitName = sessionStorage.getItem("wlx_committeeApply_unitName");
            var level = sessionStorage.getItem("wlx_committeeApply_level");
            var type = sessionStorage.getItem("wlx_committeeApply_type");
            var isPost = sessionStorage.getItem("wlx_committeeApply_isPost");
            var pageSize = Number(sessionStorage.getItem("wlx_committeeApply_pageSize"));
            var page = Number(sessionStorage.getItem("wlx_committeeApply_page"));
            if (unitName != null && unitName != undefined) {
                this.unitName = unitName;
            }
            if (level != null && level != undefined && level != "null") {
                this.level = level;
            }
            if (type != null && type != undefined && type != "null") {
                this.type = type;
            }
            if (isPost != null && isPost != undefined && isPost != "null") {
                this.isPost = isPost;
            }
            // if (schoolType != null && schoolType != undefined && schoolType != "null") {
            //     this.schoolType = schoolType;
            // }
            // if (schoolPrivince != null && schoolPrivince != undefined && schoolPrivince != "null") {
            //     this.schoolPrivince = schoolPrivince;
            // }
            if (pageSize != null && pageSize != undefined && pageSize) {
                this.pageSize = pageSize;
            }
            if (page != null && page != undefined) {
                this.page = page;
            }
        },
    },
};
</script>

<style lang="scss">
.wlx-pilot-manager {
    background: #fff;
    padding-bottom: 20px;

    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;

        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }

        .delete-banner-btn {
            margin-right: 62px;
        }

        .top-page-top {
            border: none;
        }
    }

    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }

    .el-table thead {
        color: #05243D;
    }

    .btn-right {
        margin-top: 14px;
    }

    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
